import React from 'react';
import { BsHeaderTitle } from 'components';
import { UiBsContentContainer } from 'styles';

import { BsHomeDashboard } from 'components';
// import { UiBsHomePage } from './BsHomePage.style';


/**
 * 機構概況頁面
 */

export const BsHomePage = () => {
  return (
    <>
      <BsHeaderTitle title="機構概況" />
      <UiBsContentContainer>
        <BsHomeDashboard />
      </UiBsContentContainer>
    </>
  );
};


